import { reactBinding, createForm, fields } from "rd-redux-forms";
import { getCountryListRequest } from "@common";
import { FETCH_STATE_INITIAL } from "rd-redux-http";

export interface ClientFormFields {
    accountName: string;
    email: string;
    phone: string;
    category: string;
    industry: string;
    invoice: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateOrProvince: string;
    zipCode: string;
    country: string;
}

export const clientForm = createForm<ClientFormFields>("CLIENT FORM", {
    accountName: fields.string(true),
    email: fields.string(true),
    phone: fields.string(false),
    category: fields.string(true),
    industry: fields.string(true),
    invoice: fields.string(false),
    addressLine1: fields.string(true),
    addressLine2: fields.string(false),
    city: fields.string(true),
    stateOrProvince: fields.string(false),
    zipCode: fields.string(true),
    country: fields.string(true)
});

export const clientFormBindings = reactBinding()
    .default()
    .withForm(clientForm);

export interface ClientState {
    clientForm: typeof clientForm.types.state;
    isOpenCreateClient: boolean;
    countryList: typeof getCountryListRequest.types.reduxState;
    clientSavingFlag: boolean;
}

export const defaultClientState: ClientState = {
    clientForm: clientForm.state.empty(),
    isOpenCreateClient: false,
    countryList: { fetchState: FETCH_STATE_INITIAL },
    clientSavingFlag: false
};
